import {NeoModal} from "@/components/@modal/neo.modal";
import {NeoTextBox} from "@/components/forms";
import {NeoError} from "@/components/shared";
import {useRoutePlan} from "@/context/routePlan/optimizer/routePlanVariant";
import {useVariantMap} from "@/context/routePlan/optimizer/variantMap";
import {routePlanService} from "@/service/routePlan.service";
import {yupResolver} from "@hookform/resolvers/yup";
import {useEffect, useState} from "react";
import {Controller, useForm} from "react-hook-form";
import Select from "react-select";
import * as yup from "yup";

type CreateInfowindowProps = {
  createMarkerPos: google.maps.LatLngLiteral | null;
  setCreateMarkerPos: React.Dispatch<
    React.SetStateAction<google.maps.LatLngLiteral | null>
  >;
  unmappedBpData?: UnMappedLocation | null;
  setUnmappedBpData?: any;
};
interface FormValues {
  name: string;
  latitude: string;
  longitude: string;
  routeId?: number | null;
}
const schema: yup.ObjectSchema<FormValues> = yup.object({
  name: yup.string().nullable().required(),
  latitude: yup.string().nullable().required(),
  longitude: yup.string().nullable().required(),
  routeId: yup.number().nullable()
});
export const CreateInfowindow = function ({
  createMarkerPos,
  setCreateMarkerPos,
  unmappedBpData,
  setUnmappedBpData
}: CreateInfowindowProps) {
  const {variantRoutesData} = useVariantMap();
  const [confirmPopup, setConfirmPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState<any>(null);
  const [request, setRequest] = useState<FormValues | {}>({});
  const {currentVariant, setCurrentVariant} = useRoutePlan();
  const [processingPopupmodal, setProcessingPopupmodal] = useState(false);
  const [oldCurrentVariantId, setOldCurrentVariantId] = useState<number | null>(
    null
  );
  const {refreshSingleRoute} = useVariantMap();
  const {
    register,
    handleSubmit,
    control,
    getValues,
    setError,
    setValue,
    reset,
    formState: {errors, isSubmitting}
  } = useForm<FormValues>({
    resolver: yupResolver(schema),
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      name: "",
      latitude: "",
      longitude: "",
      routeId: null
    }
  });
  useEffect(() => {
    if (createMarkerPos?.lat && createMarkerPos?.lng) {
      setValue(
        "latitude",
        createMarkerPos?.lat ? createMarkerPos?.lat.toFixed(5) : "",
        {
          shouldValidate: true,
          shouldDirty: true,
          shouldTouch: true
        }
      );
      setValue(
        "longitude",
        createMarkerPos?.lng ? createMarkerPos?.lng.toFixed(5) : "",
        {
          shouldValidate: true,
          shouldDirty: true,
          shouldTouch: true
        }
      );
    }
  }, [createMarkerPos]);

  useEffect(() => {
    if (unmappedBpData) {
      setValue("name", unmappedBpData?.name ? unmappedBpData?.name : "", {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true
      });
      setValue(
        "latitude",
        unmappedBpData?.latitude ? unmappedBpData?.latitude.toFixed(5) : "",
        {
          shouldValidate: true,
          shouldDirty: true,
          shouldTouch: true
        }
      );
      setValue(
        "longitude",
        unmappedBpData?.longitude ? unmappedBpData?.longitude.toFixed(5) : "",
        {
          shouldValidate: true,
          shouldDirty: true,
          shouldTouch: true
        }
      );
    }
  }, [unmappedBpData]);
  useEffect(() => {
    if (oldCurrentVariantId && oldCurrentVariantId !== 0) {
      handlePopupModal();
    }
  }, [oldCurrentVariantId]);

  useEffect(() => {
    if (Object.prototype.hasOwnProperty.call(request, "name")) {
      const routeId = "routeId" in request ? request.routeId : null;

      if (routeId) {
        setConfirmPopup(true);
      } else {
        addBp("");
      }
    }
  }, [request]);
  const handlePopupModal = () => {
    setProcessingPopupmodal(true);
  };
  const searchInputLoaction = () => {
    // Get values from the input fields
    const lat = parseFloat(getValues("latitude")); // Get latitude value
    const lng = parseFloat(getValues("longitude")); // Get longitude value

    // Check if the values are valid
    if (!isNaN(lat) && !isNaN(lng)) {
      // Set the latest location
      setCreateMarkerPos({lat, lng});
    } else {
      setError("latitude", {
        message: "Please enter valid latitude values."
      });
      setError("longitude", {
        message: "Please enter valid longitude values."
      });
    }
  };
  const onSubmit = (data: FormValues) => {
    setRequest(data);

    //  If enabling confirmation popup, pass request data to modal
    // s1 -> enable setConfirmPopup(true) and remove direct addBp call
    //s2 -> remove requestData param from addBp function and get request from state inside addBp function
    //addBp("option1", data);
  };
  const addBp = async (optionType: string) => {
    //option1 -> Add Boarding Point Only,option2 -> Add Boarding Point and Replan Route
    //need to change requestData to request variable name when enable confirmation popup
    setConfirmPopup(false);
    const routeId = "routeId" in request ? request.routeId : null;
    const req = {
      ...request,
      bpId: unmappedBpData?.id ? unmappedBpData.id : 0,
      sRoute: routeId ? routeId : 0,
      dRoute: routeId ? routeId : 0,
      //operation: unmappedBpData ? 2 : 1, // 2 - Edit, 1 - Add
      operation: 1, // 1 - Add
      rType: 1,
      reRoute: optionType === "option1" ? 0 : optionType === "option2" ? 2 : 0,
      mappedUsers: [],
      routePlanVariantId: currentVariant
    };
    await routePlanService
      .bpOperations(req)
      .then(async (response: any) => {
        if (response?.status === "success") {
          // if (routeId) {
          setOldCurrentVariantId(currentVariant);
          setCurrentVariant(0); //to trigger the useEffect in variant map and fetch new current variant
          //}
          setConfirmPopup(false);
          setCreateMarkerPos(null);
          reset();
        } else {
          setErrorMessage("Insufficient credit points.");
        }
      })
      .catch(err => {
        if (err?.errors?.length > 0) {
          err?.errors?.forEach(
            ({field, message}: {field: any; message: string}) => {
              setError(field, {type: "server", message: message});
            }
          );
        }
      })
      .finally(() => {
        //setLoading(false);
        setTimeout(() => {
          setErrorMessage(null);
        }, 2000);
      });
  };
  const changeVariant = () => {
    //setProcessingPopupmodal(false);

    setCurrentVariant(oldCurrentVariantId);
    const routeId = "routeId" in request ? request.routeId : null;
    if (routeId) {
      refreshSingleRoute(routeId);
    }
    setOldCurrentVariantId(0);
    if (unmappedBpData) {
      setUnmappedBpData(null);
    }
  };
  return (
    <>
      <div className="w-[260px] rounded-xl p-1 shadow-sm ring-1 ring-black/5 md:p-1">
        <section className="w-full rounded-lg border border-gray-200 bg-gray-50 px-2 py-2">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex flex-col gap-2"
          >
            <div className="flex w-full flex-col items-stretch gap-2">
              <div className="flex w-full items-center justify-between gap-2">
                <Controller
                  name="name"
                  control={control}
                  render={({field}) => (
                    <NeoTextBox
                      {...field}
                      isRequired
                      label="Stop Name"
                      placeholder="Name"
                      id="name"
                      size="sm"
                      color={errors.name ? "danger" : "default"}
                      isInvalid={errors.name ? true : false}
                      errorMessage={errors.name && `${errors.name.message}`}
                      autoComplete="off"
                      {...register("name")}
                      onChange={e => {
                        field.onChange(e);
                        //  msgreplaceword(e);
                      }}
                    />
                  )}
                />
              </div>
              <div className="flex w-full">
                <Controller
                  name="routeId"
                  control={control}
                  render={({field, fieldState}) => (
                    <div className="flex flex-col gap-1">
                      <label
                        // style={style.label}
                        id="aria-label"
                        htmlFor="aria-example-input"
                      >
                        Routes
                      </label>
                      <Select
                        name="type"
                        className="w-full"
                        options={variantRoutesData ?? []}
                        getOptionLabel={(e: any) => e.routeName}
                        getOptionValue={e => e.routeId.toString()}
                        menuPortalTarget={
                          typeof window !== "undefined" ? document.body : null
                        }
                        menuPosition="fixed"
                        menuShouldBlockScroll
                        menuShouldScrollIntoView={false}
                        closeMenuOnScroll={false}
                        // defaultValue={variantRoutesData.find(
                        //   opt => opt.routeId === defaultVehicleSingle
                        // )}
                        value={
                          field.value
                            ? (variantRoutesData?.find(
                                (o: any) =>
                                  String(o.routeId) === String(field.value)
                              ) ?? null)
                            : null
                        }
                        onChange={selectedOption => {
                          field.onChange(
                            selectedOption
                              ? String(selectedOption.routeId)
                              : null
                          );
                        }}
                        placeholder="Select Route"
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            width: "220px",
                            minHeight: "30px",
                            // padding: "3px",
                            borderWidth: "2px",
                            borderColor: "#d4d4d8",
                            borderRadius: "16px",
                            paddingLeft: "6px",
                            paddingRight: "6px",
                            boxShadow: "none",
                            fontSize: "13px",
                            color: "#000",
                            // fontWight: "bold",
                            backgroundColor: "white",
                            "&:hover": {
                              borderColor: "#d4d4d8"
                            }
                          }),
                          placeholder: base => ({
                            ...base,
                            color: "#6b7280",
                            fontSize: "14px"
                          }),
                          indicatorSeparator: () => ({
                            display: "none"
                          }),
                          dropdownIndicator: base => ({
                            ...base,
                            color: "#6b7280",
                            paddingRight: "8px"
                          }),
                          // singleValue: base => ({
                          //   ...base,
                          //   color: "#111827"
                          // }),
                          menu: base => ({
                            ...base,
                            borderRadius: "10px",
                            zIndex: 50
                          }),
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isFocused
                              ? "#e5e7eb"
                              : "white",
                            color: "#111827",
                            padding: "10px 12px",
                            cursor: "pointer",
                            borderRadius: "8px",
                            margin: "2px 4px"
                          })
                        }}
                      />
                      {fieldState.error && (
                        <p className="mt-1 text-xs text-pink-600">
                          {fieldState.error.message}
                        </p>
                      )}
                    </div>
                  )}
                />
              </div>
              <div className="grid w-full grid-cols-2 gap-2">
                <Controller
                  name="latitude"
                  control={control}
                  render={({field}) => (
                    <NeoTextBox
                      {...field}
                      isRequired
                      label="Latitude"
                      placeholder="Lat"
                      id="lat"
                      size="sm"
                      color={errors.latitude ? "danger" : "default"}
                      isInvalid={errors.latitude ? true : false}
                      errorMessage={
                        errors.latitude && `${errors.latitude.message}`
                      }
                      readOnly={unmappedBpData?.latitude ? true : false}
                      autoComplete="off"
                      {...register("latitude")}
                      onChange={e => {
                        field.onChange(e);
                        //  msgreplaceword(e);
                      }}
                    />
                  )}
                />
                <Controller
                  name="longitude"
                  control={control}
                  render={({field}) => (
                    <NeoTextBox
                      {...field}
                      isRequired
                      label="Latitude"
                      placeholder="Lng"
                      id="lng"
                      size="sm"
                      readOnly={unmappedBpData?.longitude ? true : false}
                      color={errors.longitude ? "danger" : "default"}
                      isInvalid={errors.longitude ? true : false}
                      errorMessage={
                        errors.longitude && `${errors.longitude.message}`
                      }
                      autoComplete="off"
                      {...register("longitude")}
                      onChange={e => {
                        field.onChange(e);
                        //  msgreplaceword(e);
                      }}
                    />
                  )}
                />
              </div>
              {errorMessage ? (
                <NeoError message={errorMessage}></NeoError>
              ) : null}
              {!unmappedBpData && (
                <div className="flex w-full items-center justify-end">
                  <a
                    href="#"
                    onClick={e => {
                      e.preventDefault();
                      searchInputLoaction();
                    }}
                    className="float-end mb-2 text-xs text-blue-600 underline hover:text-blue-800"
                  >
                    Search Input Location
                  </a>
                </div>
              )}

              <div className="mb-3 mt-3 flex w-full items-center justify-end gap-2">
                {" "}
                <button
                  type="submit"
                  className="rounded-lg bg-black px-4 py-1  text-sm font-medium text-white hover:bg-gray-800"
                  //className="rounded-lg bg-black px-4 py-1 text-sm font-medium text-white hover:bg-gray-800"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </section>
      </div>
      <NeoModal
        actionType={"boardingConformation"}
        onOpen={confirmPopup}
        onClose={() => setConfirmPopup(false)}
        hasActions={false}
        data={{
          message: {
            title: "Add Boarding Point And Replan Route",
            options: {
              // option1: {
              //   subTitle: "Add Boarding Point Only",
              //   content:
              //     "Add this Boarding Point from the route. The current route will remain unchanged."
              // },
              option2: {
                subTitle: "Add Boarding Point And Replan Route",
                content:
                  "Add this Boarding Point and re-optimize the route to adding this stop, improving the route for the remaining boarding points."
              }
            }
          },
          onConfirm: addBp,
          reqData: {...request}
        }}
      ></NeoModal>
      <NeoModal
        actionType={"routePlanProcessingPopup"}
        onOpen={processingPopupmodal}
        onClose={() => setProcessingPopupmodal(false)}
        hasActions={false}
        data={{
          changeVariant,
          newAddedVariantId: oldCurrentVariantId,
          type: "addBP"
        }}
      ></NeoModal>
    </>
  );
};
